$(function () {
  if (!customElements.get('products-select-menu')) {
    customElements.define(
      'products-select-menu',
      class productsSelectMenu extends HTMLElement {
        constructor() {
          super();
          this.container = null;
          this.header = null;
          this.valueSpan = null;
          this.optionsList = null;
          this.optionsContainer = null;
          this.arrowIcon = null;
          this.$current_inventory_quantity = 0;
          this.$currentPrice = 0;
          this.$currentId = 0;
          this.$currentComparePrice = 0;
          this.$currentRecommendId = 0;
          this.$currentQuantity = 1;
          this.productId = null;
          this._documentClickBound = false;
          this.totalPrice = 0;
          this.totalComparePrice = 0;
          this.totalDiscount = 0;
          this.priceContribution = {
            price: 0,
            comparePrice: 0,
            discount: 0,
          };
          this.shopMoneyFormat = window.shopMoneyFormat;
        }

        connectedCallback() {
          this.container = this.querySelector('div');
          this.header = this.querySelector('.select-header');
          this.valueSpan = this.querySelector('.select-value');
          this.optionsList = this.querySelector('ul');
          this.optionsContainer = this.querySelector('.select-options');
          this.arrowIcon = this.querySelector('.arrow-icon');
          this.productId = this.getAttribute('data-product-id');
          this.$priceContainer = $('.price-container');
          this.$productStickyFormTotal = $('.product-sticky-form-total');

          this.openVariantPopup();
          if (!this.header || !this.optionsList || !this.optionsContainer) {
            console.error('Required elements not found:', {
              header: !!this.header,
              optionsList: !!this.optionsList,
              optionsContainer: !!this.optionsContainer,
            });
            return;
          }

          this.checkboxClick();
          this.bindEvents();
          this.initEveryOption();
          this.openProductDetails();
        }
        checkboxClick() {
          // 获取最外层容器
          this.containerDiv = this.querySelector('.products-select-item');
          // 获取复选框和其他元素
          const checkboxImage = this.querySelector(`.checkbox-image-${this.productId}`);
          const checkboxTitle = this.querySelector(`.checkbox-title-${this.productId}`);
          const checkboxContainer = this.querySelector(`.checkbox-container-${this.productId}`);
          console.log('checkboxContainer111', checkboxContainer);
          this.checkbox = checkboxContainer.querySelector('input[type="checkbox"]');

          // 为 checkbox 本身添加点击事件处理
          if (this.checkbox) {
            this.checkbox.addEventListener('click', (e) => {
              // 阻止事件冒泡
              e.stopPropagation();
            });
          }

          // 为图片和标题添加点击事件
          const handleClick = (e) => {
            // 阻止事件冒泡
            e.stopPropagation();

            console.log('进来333', checkboxContainer);
            console.log('进来111', this.checkbox);

            if (this.checkbox) {
              console.log('当前checkbox状态:', this.checkbox.checked);
              const currentState = this.checkbox.checked;
              this.checkbox.checked = !currentState;

              // 手动触发 change 事件
              this.checkbox.dispatchEvent(new Event('change'));
            }
          };

          if (checkboxImage) {
            checkboxImage.addEventListener('click', handleClick);
          }
          if (checkboxTitle) {
            checkboxTitle.addEventListener('click', handleClick);
          }
          if (checkboxContainer) {
            checkboxContainer.addEventListener('click', handleClick);
          }

          // 初始化全局选中产品数组（如果不存在）
          window.selectedProducts = window.selectedProducts || [];

          // 绑定复选框change事件
          if (this.checkbox && this.containerDiv) {
            this.checkbox.addEventListener('change', (e) => {
              if (e.target.checked) {
                // 添加到全局选中产品数组
                const productData = {
                  variantId: this.$currentId,
                  quantity: this.$currentQuantity,
                };

                // 检查是否已存在，如果存在则更新
                const existingIndex = window.selectedProducts.findIndex(
                  (p) => p.variantId === this.$currentId || p.productId === this.productId
                );

                if (existingIndex !== -1) {
                  window.selectedProducts[existingIndex] = productData;
                } else {
                  window.selectedProducts.push(productData);
                }
                console.log('执行6', window.selectedProducts);
                console.log('执行7', this.$currentId);

                this.containerDiv.classList.add('border-primary');
                this.updateTotalPrices(true, 'checkboxContainer');
              } else {
                this.containerDiv.classList.remove('border-primary');
                // 确保从数组中移除当前变体
                window.selectedProducts = window.selectedProducts.filter(
                  (p) => p.variantId !== this.$currentId && p.productId !== this.productId
                );
                this.updateTotalPrices(false);
              }

              console.log('Selected products updated:', window.selectedProducts);
            });
          }
        }
        bindEvents() {
          // 点击header展开/收起
          $(this.header).on('click', (e) => {
            e.stopPropagation();
            this.toggle();
          });

          // 点击选项 - 修改事件委托的方式
          $(this.optionsList).on('click', 'li.select-option', (e) => {
            e.stopPropagation();
            const selectOption = e.target.closest('.select-option');
            this.$current_inventory_quantity = selectOption.getAttribute('data-inventory_quantity');
            console.log('执行53', this.$current_inventory_quantity);
            if (this.$current_inventory_quantity != 0) {
              this.selectOption(selectOption);
            }
          });

          // 点击外部关闭 - 确保事件只绑定一次
          if (!this._documentClickBound) {
            $(document).on('click', (e) => {
              if (!this.contains(e.target)) {
                this.close();
              }
            });
            this._documentClickBound = true;
          }
        }

        toggle() {
          const $header = $(this.header);
          const $optionsContainer = $(this.optionsContainer);
          const $arrowIcon = $(this.arrowIcon);
          const isActive = $header.hasClass('active-select-menu');

          if (!isActive) {
            // 展开
            $header.addClass('active-select-menu');
            $optionsContainer
              .css({
                'max-height': '300px',
                opacity: '1',
              })
              .addClass('!max-h-[300px] !opacity-100');
            $(this.valueSpan).css('color', '#acacac');
            $arrowIcon.css('transform', 'rotate(-180deg)');
          } else {
            // 收起
            this.close();
          }
        }

        close() {
          const $header = $(this.header);
          const $optionsContainer = $(this.optionsContainer);
          const $arrowIcon = $(this.arrowIcon);

          $header.removeClass('active-select-menu');
          $optionsContainer
            .css({
              'max-height': '0',
              opacity: '0',
            })
            .removeClass('!max-h-[300px] !opacity-100');
          $(this.valueSpan).css('color', '');
          $arrowIcon.css('transform', '');
        }

        parsePriceString(priceString) {
          return priceString;
        }

        selectOption(option) {
          if (!option) return;

          const $option = $(option);
          const value = $option.find('span').text().trim();
          const inventoryQuantity = option.getAttribute('data-inventory_quantity');
          const price = option.getAttribute('data-price');
          const comparePrice = option.getAttribute('data-compare_at_price');
          const variantId = option.getAttribute('data-id');
          const recommendId = option.getAttribute('data-recommend-id');

          // 先更新当前状态，确保使用新的价格
          this.$current_inventory_quantity = inventoryQuantity;
          this.$currentPrice = this.parsePriceString(price);
          this.$currentComparePrice = this.parsePriceString(comparePrice);
          this.$currentId = variantId;
          this.$currentRecommendId = recommendId;

          // 更新数量输入框
          const quantityInput = this.querySelector('.option-container input[type="text"]');
          console.log('quantityInputquantityInput22', quantityInput);
          if (quantityInput) {
            // 更新最大值
            quantityInput.max = inventoryQuantity;
            // 每次切换选项时重置数量为1
            this.$currentQuantity = 1;
            quantityInput.value = 1;
          }
          console.log('quantityInputquantityInput', quantityInput);
          // 更新价格显示
          const $priceContainer = $(`.select-price-option-${recommendId}`);
          const $comparePriceContainer = $(`.select-compare-price-${recommendId}`);
          const $comparePriceContainerOut = $(`.select-compare-price-container-${recommendId}`);
          if ($priceContainer.length) {
            $priceContainer.text(price);
          }
          console.log('comparePrice', comparePrice);
          if ($comparePriceContainer.length) {
            if (comparePrice != 0) {
              $comparePriceContainerOut.removeClass('hidden');
              $comparePriceContainer.text(comparePrice);
            } else {
              $comparePriceContainer.text('');
              $comparePriceContainerOut.addClass('hidden');
            }
          } else {
            $comparePriceContainer.text('');
            $comparePriceContainerOut.addClass('hidden');
          }

          // 移除所有选项的高亮效果，并给当前选中项添加高亮
          $(this.optionsList).find('.select-option').removeClass('text-orange-500 selected');
          $option.addClass('text-orange-500 selected');

          // 自动勾选 checkbox
          if (this.checkbox && !this.checkbox.checked) {
            this.checkbox.checked = true;
            this.containerDiv.classList.add('border-primary');

            // 添加到已选商品数组
            window.selectedProducts.push({
              productId: this.productId,
              variantId: parseInt(variantId),
              quantity: this.$currentQuantity,
            });
            // 更新总价
            this.updateTotalPrices(true);
          }

          // 如果这个商品已经被选中（checkbox已勾选）
          if (this.checkbox && this.checkbox.checked) {
            // 从已选商品数组中移除该商品的旧变体（如果存在）
            window.selectedProducts = window.selectedProducts.filter(
              (p) => !(p.productId === this.productId || p.variantId === this.$currentId)
            );

            // 添加新选择的变体
            window.selectedProducts.push({
              productId: this.productId,
              variantId: parseInt(variantId),
              quantity: this.$currentQuantity,
            });
            // 更新总价
            this.updateTotalPrices(true);
          }

          // 更新显示
          this.valueSpan.innerHTML = value;
          this.close();
        }

        initEveryOption() {
          // 获取第一个选项的信息，限定在当前产品范围内
          const firstOption = this.querySelector('.select-options-item');
          if (firstOption) {
            this.$current_inventory_quantity = firstOption.getAttribute('data-inventory_quantity');
            this.$currentPrice = this.parsePriceString(firstOption.getAttribute('data-price'));
            this.$currentId = this.parsePriceString(firstOption.getAttribute('data-id'));
            this.$currentComparePrice = this.parsePriceString(firstOption.getAttribute('data-compare_at_price'));
            this.$currentRecommendId = this.parsePriceString(firstOption.getAttribute('data-recommend-id'));
          }
          // 获取复选框元素

          // 设置数量输入框，限定在当前产品范围内
          const quantityContainer = this.querySelector('.option-container');
          const quantityInput = quantityContainer.querySelector('input[type="text"]');

          if (quantityInput) {
            quantityInput.max = this.$current_inventory_quantity;
            quantityInput.addEventListener('input', (event) => {
              const oldQuantity = this.$currentQuantity;
              const newQuantity = event.target.value;
              console.log('newQuantity', newQuantity);
              // 如果复选框已经选中，先减去旧价格
              if (this.checkbox && this.checkbox.checked) {
                // 先减去旧价格
                const oldTotal = this.$currentPrice * oldQuantity;
                const oldCompareTotal = this.$currentComparePrice * oldQuantity;
                this.totalPrice -= oldTotal;
                this.totalComparePrice -= oldCompareTotal;
              }
              if (newQuantity) {
                this.$currentQuantity = newQuantity;
              } else {
                // this.$currentQuantity = 1;
              }

              // 如果复选框已经选中，加上新价格
              if (this.checkbox && this.checkbox.checked) {
                console.log('执行1');

                this.updateTotalPrices(true);
              } else if (newQuantity > 0 && this.$current_inventory_quantity > newQuantity) {
                console.log('执行2');
                // 如果数量大于0且复选框未选中，选中复选框
                this.checkbox.checked = true;
                this.containerDiv.classList.add('border-primary');
                // 当添加 border-primary 类时，同步更新 selectedProducts
                const existingProductIndex = window.selectedProducts.findIndex(
                  (p) => p.productId === this.productId || p.variantId === this.$currentId
                );

                if (existingProductIndex === -1) {
                  // 如果商品不在列表中，添加它
                  window.selectedProducts.push({
                    productId: this.productId,
                    variantId: parseInt(this.$currentId),
                    quantity: parseInt(newQuantity),
                  });
                } else {
                  // 如果商品已在列表中，更新数量
                  window.selectedProducts[existingProductIndex].quantity = parseInt(newQuantity);
                }
                this.updateTotalPrices(true);
              }

              this.updateOptionPrice();
              console.log('Updated selectedProducts:', window.selectedProducts);
            });
          }

          // 监听当前组件的数量变化事件
          this.addEventListener('quantityChange', (event) => {
            const oldQuantity = this.$currentQuantity;
            const newQuantity = parseInt(event.detail);
            // 如果复选框已经选中，先减去旧价格
            if (this.checkbox && this.checkbox.checked) {
              const oldTotal = this.$currentPrice * oldQuantity;
              const oldCompareTotal = this.$currentComparePrice * oldQuantity;
              this.totalPrice -= oldTotal;
              this.totalComparePrice -= oldCompareTotal;
            }
            console.log('newQuantity', newQuantity);
            if (newQuantity) {
              this.$currentQuantity = newQuantity;
            }

            // 如果复选框已经选中，加上新价格
            if (this.checkbox && this.checkbox.checked) {
              // 更新已选商品数组中的数量
              const existingIndex = window.selectedProducts.findIndex(
                (p) => p.productId === this.productId || p.variantId === this.$currentId
              );
              if (existingIndex !== -1) {
                window.selectedProducts[existingIndex].quantity = parseInt(newQuantity);
              }
              this.updateTotalPrices(true);
              console.log('执行5');
            } else if (newQuantity > 0 && this.$current_inventory_quantity > newQuantity) {
              // 如果数量大于0且复选框未选中，选中复选框
              this.checkbox.checked = true;
              this.containerDiv.classList.add('border-primary');
              // 添加到已选商品数组
              const existingProductIndex = window.selectedProducts.findIndex(
                (p) => p.productId === this.productId || p.variantId === this.$currentId
              );

              if (existingProductIndex === -1) {
                // 如果商品不在列表中，添加它
                window.selectedProducts.push({
                  productId: this.productId,
                  variantId: parseInt(this.$currentId),
                  quantity: parseInt(newQuantity),
                });
              } else {
                console.log('执行10');
                // 如果商品已在列表中，更新数量
                window.selectedProducts[existingProductIndex].quantity = parseInt(newQuantity);
              }
              console.log('执行4');
              this.updateTotalPrices(true);
            }

            this.updateOptionPrice();
            console.log('Updated selectedProducts:', window.selectedProducts);
          });

          this.updateOptionPrice();
        }

        updateOptionPrice() {
          const priceSection = this.querySelector('.product-select-form-price');
          if (!priceSection) return;

          // 使用唯一的类名选择器
          const priceElement = priceSection.querySelector(`.select-price-${this.productId}`);
          const comparePriceElement = priceSection.querySelector(`.select-compare-price-${this.productId}`);

          if (priceElement && this.$currentPrice && this.$currentQuantity) {
            // 计算总价
            const totalPrice = this.$currentPrice * this.$currentQuantity;

            // 更新价格显示
            priceElement.innerHTML = window.Shopify.formatMoney(totalPrice, this.shopMoneyFormat);

            // 如果有比较价格，也更新比较价格
            if (comparePriceElement && this.$currentComparePrice) {
              const totalComparePrice = this.$currentComparePrice * this.$currentQuantity;

              comparePriceElement.innerHTML = window.Shopify.formatMoney(totalComparePrice, this.shopMoneyFormat);
            } else {
              if (this.$currentComparePrice * this.$currentQuantity == 0) {
                comparePriceElement.innerHTML = '';
              }
            }
          }
        }

        updateTotalPrices(isAdd, type = '') {
          console.log('执行updateTotalPrices', isAdd);
          console.log('this.$productStickyFormTotal', this.$productStickyFormTotal);
          const currentPrice = this.$currentPrice * this.$currentQuantity;
          const currentComparePrice = this.$currentComparePrice * this.$currentQuantity;
          const currentDiscount = currentComparePrice - currentPrice;

          // 更新全局价格显示
          if (this.$priceContainer.length > 0) {
            const priceElement = this.$priceContainer.find('.price');
            const comparePriceElement = this.$priceContainer.find('.compare_at_price');
            const discountElement = this.$priceContainer.find('.actual_discount');
            const actualDiscountContainer = this.$priceContainer.find('.actual_discount-total-container');

            this.updateAmount(
              priceElement,
              comparePriceElement,
              discountElement,
              isAdd,
              currentPrice,
              currentComparePrice,
              currentDiscount,
              actualDiscountContainer,
              type
            );
          }
          if (this.$productStickyFormTotal.length > 0) {
            const priceElement = this.$productStickyFormTotal.find('.price');
            const comparePriceElement = this.$productStickyFormTotal.find('.compare_at_price');
            const discountElement = this.$productStickyFormTotal.find('.actual_discount');
            const actualDiscountContainer = this.$productStickyFormTotal.find('.actual_discount-container');
            this.updateAmount(
              priceElement,
              comparePriceElement,
              discountElement,
              isAdd,
              currentPrice,
              currentComparePrice,
              currentDiscount,
              actualDiscountContainer,
              type
            );
          }
        }

        updateAmount(
          priceElement,
          comparePriceElement,
          discountElement,
          isAdd,
          currentPrice,
          currentComparePrice,
          currentDiscount,
          actualDiscountContainer,
          type
        ) {
          let currentVarTotal = 0;
          let currentCompareVarTotal = 0;

          if (this.$productStickyFormTotal.attr('data-current-currentQuantity')) {
            this.$productStickyFormTotal.attr('data-current-currentQuantity');
          }

          // 计算新总值（以分为单位）

          // 生成当前数组
          let productselectMenuList = document.querySelectorAll('.products-select-menu');
          const firstOption = this.querySelector('.select-options-item');
          this.$current_inventory_quantity = firstOption.getAttribute('data-inventory_quantity');
          let firstRecommendId = this.parsePriceString(firstOption.getAttribute('data-id'));

          productselectMenuList.forEach((element) => {
            let recommendId = element.getAttribute('data-product-id');
            let currentId = element.getAttribute('data-variant-current-id');
            if (recommendId == this.$currentRecommendId) {
              console.log('currentId', currentId);
              if (
                this.$currentId == firstRecommendId &&
                this.$current_inventory_quantity <= 0 &&
                type == 'checkboxContainer'
              ) {
                window.GlobalPrompt.show(window.i18n.noStock, 'error');
                this.checkbox.checked = false;
                this.containerDiv.classList.remove('border-primary');
                console.log('到这里了', window.selectedProducts);
                window.selectedProducts = window.selectedProducts.filter((p) => p.variantId !== this.$currentId);
                return false;
              }
              console.log('currentId', currentId);
              console.log('recommendId', recommendId);
              element.setAttribute('data-current-price', isAdd ? this.$currentPrice : 0);
              element.setAttribute('data-compare-price', isAdd ? this.$currentComparePrice : 0);
              element.setAttribute('data-quantity', this.$currentQuantity);
              element.setAttribute('data-variant-current-id', this.$currentId);
            }
          });
          productselectMenuList.forEach((element) => {
            const currentPrice = parseFloat(element.getAttribute('data-current-price') || 0);
            const comparePrice = parseFloat(element.getAttribute('data-compare-price') || 0);
            const quantity = parseFloat(element.getAttribute('data-quantity') || 0);

            // 计算并累加总金额
            currentVarTotal += currentPrice * quantity;
            currentCompareVarTotal += comparePrice * quantity;
          });

          let productStickyFormTotal = document.querySelector('.product-sticky-form-total');
          let priceContainer = productStickyFormTotal.querySelector('.price-container');
          let dataCurrentPriceTotal = 0;
          let dataCurrentComparePriceTotal = 0;
          let currentquantity = document
            .querySelector('.product-sticky-form-total')
            .getAttribute('data-current-currentquantity')
            ? document.querySelector('.product-sticky-form-total').getAttribute('data-current-currentquantity')
            : 1;
          if (priceContainer) {
            let dataCurrentPrice = priceContainer.getAttribute('data-current-price');
            dataCurrentPriceTotal = this.parsePriceString(dataCurrentPrice) * currentquantity;

            document.querySelectorAll('.price').forEach((element) => {
              element.innerHTML = window.Shopify.formatMoney(
                dataCurrentPriceTotal + currentVarTotal,
                this.shopMoneyFormat
              );
            });
          }
          // 更新显示（转换回美元并格式化）
          if (priceElement.length) {
            let dataCurrentComparePrice = priceContainer.getAttribute('data-compare-price');
            dataCurrentComparePriceTotal = this.parsePriceString(dataCurrentComparePrice) * currentquantity;
            document.querySelectorAll('.compare_at_price').forEach((element) => {
              element.innerHTML = window.Shopify.formatMoney(
                dataCurrentComparePriceTotal + currentCompareVarTotal,
                this.shopMoneyFormat
              );
            });
          }

          // 计算折扣
          let discount_total_price = dataCurrentPriceTotal + currentVarTotal;
          let discount_total_compare = dataCurrentComparePriceTotal + currentCompareVarTotal;
          this.$priceContainer = $('.price-container');
          let actual_discount = this.$priceContainer.find('.actual_discount');
          console.log('discount_total_price', discount_total_price);
          console.log('discount_total_compare', discount_total_compare);

          if (document.querySelector('global-discount')) {
            document
              .querySelector('global-discount')
              .setAttribute(
                'data-total',
                JSON.stringify({ price: discount_total_price, compare_price: discount_total_compare })
              );
          }
          if (discount_total_price != 0 && discount_total_compare != 0) {
            const discount = discount_total_compare - discount_total_price;
            console.log('discount', discount);
            console.log('discount', typeof discount);

            if (discount > 0) {
              actualDiscountContainer.removeClass('hidden');
              actual_discount.removeClass('hidden');
              console.log('可以进来啊', actual_discount);

              actual_discount.text(window.Shopify.formatMoney(discount * 100, this.shopMoneyFormat));
            } else {
              actualDiscountContainer.addClass('hidden');
              actual_discount.addClass('hidden');
            }
          } else {
            actualDiscountContainer.addClass('hidden');
            actual_discount.addClass('hidden');
          }

          const changeFavourable = new CustomEvent('changeFavourable', {
            detail: true,
          });
          window.dispatchEvent(changeFavourable); // 触发事件
        }
        parsePriceString(priceString) {
          return priceString;
        }

        openVariantPopup() {
          const $variantContainer = this.querySelector('.variant-container');
          // 检查元素是否存在
          if (!$variantContainer) {
            console.warn('Variant container not found');
            return;
          }

          customEventListener($variantContainer, 'click', () => {
            const $productDetailModal = this.querySelector('product-detail-data-variant-popup');
            // 检查弹窗元素是否存在
            if (!$productDetailModal) {
              console.warn('Product detail modal not found');
              return;
            }

            $productDetailModal.classList.remove('hidden');
            // 添加关闭弹窗的逻辑
            const closeModal = (e) => {
              if (e.target === $productDetailModal) {
                $productDetailModal.classList.add('hidden');
                document.removeEventListener('click', closeModal);
              }
            };
            document.addEventListener('click', closeModal);
          });
        }
        openProductDetails() {
          this.querySelector('.open-product-details').addEventListener('click', () => {
            console.log('执行2');
            // 获取当前产品ID
            const productId = this.getAttribute('data-product-id');
            if (!productId) {
              console.warn('Product ID not found');
              return;
            }

            // 获取对应产品ID的弹窗元素
            const $modal = document.querySelector(
              `.product-detail-data-modal[data-product-detail-data-id="${productId}"]`
            );
            console.log('productId', productId);
            console.log('modal', $modal);
            if (!$modal) {
              console.warn(`Modal for product ${productId} not found`);
              return;
            }

            // 显示弹窗
            $modal.classList.remove('hidden');

            // 添加点击空白区域关闭弹窗
            const closeModal = (e) => {
              if (e.target === $modal) {
                $modal.classList.add('hidden');
                document.removeEventListener('click', closeModal);
              }
            };
            document.addEventListener('click', closeModal);
          });
        }
      }
    );
  }
});
